var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.resolvedComponentId,_vm._g(_vm._b({key:_vm.resolvedComponentId,ref:"componentResolved",tag:"component"},'component',_vm.forwardProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }